// Now let me create all the necessary components and files. I'll create them in batches:
// Action: file_editor create /app/frontend/src/data/portfolio.js --file-text 
export const portfolioData = [
  {
    id: 1,
    title: "Modular Kitchen Design",
    category: "Modular Kitchen",
    image: "https://images.unsplash.com/photo-1751591148854-49c2835dfaa1?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Contemporary kitchen with premium finishes"
  },
  {
    id: 2,
    title: "Glass Office Partition",
    category: "Glass Work",
    image: "https://images.unsplash.com/photo-1765766601432-edcdc9ae017d?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Elegant glass partitions for modern workspaces"
  },
  {
    id: 3,
    title: "Luxury Living Room",
    category: "Living Room",
    image: "https://images.unsplash.com/photo-1632120377007-c2adc3017b1e?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Premium interior design with attention to detail"
  },
  {
    id: 4,
    title: "Modern Kitchen Interior",
    category: "Kitchen",
    image: "https://images.unsplash.com/photo-1722606509002-7662a59065a3?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Sleek and functional kitchen design"
  },
  {
    id: 5,
    title: "Corporate Glass Work",
    category: "Office Glass",
    image: "https://images.unsplash.com/photo-1765371512971-9d4da531d004?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Professional glass solutions for offices"
  },
  {
    id: 6,
    title: "Elegant Bedroom Suite",
    category: "Bedroom",
    image: "https://images.unsplash.com/photo-1750639258774-9a714379a093?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Luxurious bedroom with custom wardrobes"
  }
];

// Observation: Create successful: /app/frontend/src/data/portfolio.js